export default __webpack_public_path__ + "static/media/leftCardBoard.5a42920a.jpg";